module.exports = __webpack_public_path__ + "img/open.e5a378d9.jpg";